import React from "react";

const ChartType = ({ setting, setSetting }) => {

  const handleUpdate = (key, value) => {
    setSetting((prevSetting) => ({
      ...prevSetting,
      [key]: value,
    }));
  };
  return (
    <div className="bg-custom text-gray-900 m-1 rounded overflow-hidden md:ml-4 ml-0 shadow-lg overflow-visible col-span-2">
      <div className="px-1 py-2">
        <div className="space-y-1 mt-4">
          <div className="flex flex-row">
            <table className="table-auto" style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <th align={"left"}>Type</th>
                  <td>
                    <select
                      id="chartTypeMode"
                      value={setting.chartType}
                      onChange={(e) =>
                        setSetting({ ...setting, chartType: e.target.value })
                      }
                      className="text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="candlestick">Candlestick</option>
                      <option value="ohlc">OHLC Bars</option>
                      <option value="solid">Solid line</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th align={"left"}>Volume</th>
                  <td>
                    <select
                      id="chartOverlay"
                      value={setting.chartOverlay}
                      onChange={(e) =>
                        setSetting({ ...setting, chartOverlay: e.target.value })
                      }
                      className="text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="on">Over</option>
                      <option value="off">OFF</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  {/*<td>*/}
                  {/*  <input*/}
                  {/*      id="quote"*/}
                  {/*      type="checkbox"*/}
                  {/*      checked={setting.quote}*/}
                  {/*      onChange={() => handleUpdate("quote", !setting.quote)}*/}
                  {/*      className="mr-2 w-4 h-4 text-blue-500 border-gray-300 rounded"*/}
                  {/*  />*/}
                  {/*  <label className="text-gray-700 text-sm font-bold" htmlFor="grid1">*/}
                  {/*    Full Quote*/}
                  {/*  </label>*/}
                  {/*</td>*/}
                  <td colSpan={2} style={{ textAlign: "right" }}>
                    <input
                      id="grid2"
                      type="checkbox"
                      checked={setting.enablePrice}
                      onChange={() => handleUpdate("enablePrice", !setting.enablePrice)}
                      className="mr-2 w-4 h-4 text-blue-500 border-gray-300 rounded"
                    />
                    <label className="text-gray-700 text-sm font-bold" htmlFor="grid2">
                      Price Labels
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartType;
